import { render } from "./SubscribeApp.vue?vue&type=template&id=0f064423"
import script from "./SubscribeApp.vue?vue&type=script&lang=js"
export * from "./SubscribeApp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__